var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail-view pd-mdeium-horizontal" }, [
    _vm.auditResult != null
      ? _c("div", { staticClass: "view-box" }, [
          _c("div", { staticClass: "view-title" }, [_vm._v("最近审核记录")]),
          _vm._v(" "),
          _c("ul", { staticClass: "audit-result" }, [
            _c("li", [
              _c("span", [_vm._v("审核结果：")]),
              _vm._v(" "),
              _vm.auditResult.auditState == 2
                ? _c("span", { staticClass: "red" }, [_vm._v("已入驻")])
                : _vm._e(),
              _vm._v(" "),
              _vm.auditResult.auditState == 1
                ? _c("span", { staticClass: "red" }, [_vm._v("已驳回")])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.auditResult.reason != ""
              ? _c("li", [
                  _c("span", [_vm._v("驳回理由：")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "black" }, [
                    _vm._v(_vm._s(_vm.auditResult.reason))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("li", [
              _c("span", [_vm._v("审核时间：")]),
              _vm._v(" "),
              _c("span", { staticClass: "black" }, [
                _vm._v(
                  _vm._s(_vm._f("timeStampFormat")(_vm.auditResult.auditTime))
                )
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.shopDetail != null
      ? _c("div", { staticClass: "view-box" }, [
          _c("div", { staticClass: "view-title" }, [_vm._v("店铺信息")]),
          _vm._v(" "),
          _c("div", { staticClass: "shop-detail" }, [
            _c("ul", [
              _c("li", [
                _c("span", [_vm._v("店铺LOGO：")]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "pic-box",
                    on: {
                      click: function($event) {
                        _vm.showPicPopup(_vm.shopDetail.logo)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.shopDetail.logo, alt: "店铺logo" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("div", { staticClass: "sub-list-item" }, [
                  _c("p", [
                    _c("span", [_vm._v("店铺名称：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.shopDetail.shopName))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", [_vm._v("创建时间：")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("timeStampFormat")(_vm.shopDetail.createAt)
                        )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sub-list-item" }, [
                  _c("p", [
                    _c("span", [_vm._v("店铺类型：")]),
                    _vm._v(" "),
                    _vm.shopDetail.shopType == 1
                      ? _c("span", [_vm._v("企业店铺")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shopDetail.shopType == 2
                      ? _c("span", [_vm._v("个体店铺")])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", [_vm._v("经营者姓名：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.shopDetail.managerName))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sub-list-item" }, [
                  _c("p", [
                    _c("span", [_vm._v("所在城市：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.shopDetail.cityName))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", [_vm._v("经营者身份证号码：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.shopDetail.managerCard))])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", [_vm._v("经营者身份证照片：")]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "pic-box",
                    on: {
                      click: function($event) {
                        _vm.showPicPopup(_vm.shopDetail.cardFront)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.shopDetail.cardFront, alt: "" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "pic-box",
                    on: {
                      click: function($event) {
                        _vm.showPicPopup(_vm.shopDetail.cardBack)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.shopDetail.cardBack, alt: "" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "pic-box",
                    on: {
                      click: function($event) {
                        _vm.showPicPopup(_vm.shopDetail.cardTogerther)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.shopDetail.cardTogerther, alt: "" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "category" }, [
                _c("span", [_vm._v("经营类目：")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "category-list" },
                  _vm._l(_vm.shopDetail.shopCatalogDtoList, function(
                    firstItem,
                    firstIndex
                  ) {
                    return _c(
                      "div",
                      { key: firstIndex, staticClass: "category-item" },
                      [
                        _c("div", { staticClass: "first" }, [
                          _vm._v(_vm._s(firstItem.catagoryName))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "second" },
                          _vm._l(firstItem.childList, function(
                            secItem,
                            secIndex
                          ) {
                            return _c(
                              "div",
                              { key: secIndex, staticClass: "second-item" },
                              [
                                _c("p", [_vm._v(_vm._s(secItem.catagoryName))]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  _vm._l(secItem.childList, function(
                                    thirdItem,
                                    thirdIndex
                                  ) {
                                    return _c("i", { key: thirdIndex }, [
                                      _vm._v(_vm._s(thirdItem.catagoryName))
                                    ])
                                  })
                                )
                              ]
                            )
                          })
                        )
                      ]
                    )
                  })
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", [_vm._v("店铺联系电话：")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.shopDetail.telephone))])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.qualification != null
      ? _c("div", { staticClass: "view-box" }, [
          _c("div", { staticClass: "view-title" }, [_vm._v("店铺资质")]),
          _vm._v(" "),
          _c("div", { staticClass: "shop-aptitude" }, [
            _c("ul", [
              _c("li", [
                _vm.qualification.companyName != ""
                  ? _c("div", { staticClass: "sub-list-item" }, [
                      _c("p", [
                        _c("span", [_vm._v("公司名称：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.qualification.companyName))
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.qualification.legalPerson != ""
                  ? _c("div", { staticClass: "sub-list-item" }, [
                      _c("p", [
                        _c("span", [_vm._v("法人姓名：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.qualification.legalPerson))
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.qualification.idCardNo != ""
                  ? _c("div", { staticClass: "sub-list-item" }, [
                      _c("p", [
                        _c("span", [_vm._v("法人身份证号码：")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.qualification.idCardNo))])
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.qualification.idCardFrontPic != ""
                ? _c("li", [
                    _c("span", [_vm._v("法人身份证照片：")]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "pic-box",
                        on: {
                          click: function($event) {
                            _vm.showPicPopup(_vm.qualification.idCardFrontPic)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.qualification.idCardFrontPic,
                            alt: ""
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "pic-box",
                        on: {
                          click: function($event) {
                            _vm.showPicPopup(_vm.qualification.idCardBackPic)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.qualification.idCardBackPic,
                            alt: ""
                          }
                        })
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.qualification.certificateNo != ""
                ? _c("li", [
                    _c("span", [_vm._v("营业执照编号：")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.qualification.certificateNo))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.qualification.certificationPic != ""
                ? _c("li", [
                    _c("span", [_vm._v("营业执照照片：")]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "pic-box",
                        on: {
                          click: function($event) {
                            _vm.showPicPopup(_vm.qualification.certificationPic)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.qualification.certificationPic,
                            alt: ""
                          }
                        })
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.qualification.orgCode != ""
                ? _c("li", [
                    _c("span", [_vm._v("组织机构代码：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.qualification.orgCode))])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.qualification.orgCertificatePic != ""
                ? _c("li", [
                    _c("span", [_vm._v("组织机构代码证照片：")]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "pic-box",
                        on: {
                          click: function($event) {
                            _vm.showPicPopup(
                              _vm.qualification.orgCertificatePic
                            )
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.qualification.orgCertificatePic,
                            alt: ""
                          }
                        })
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.qualification.taxCertificateNo != ""
                ? _c("li", [
                    _c("span", [_vm._v("税务登记证号：")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.qualification.taxCertificateNo))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.qualification.taxCertificatePic != ""
                ? _c("li", [
                    _c("span", [_vm._v("税务登记证照片：")]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "pic-box",
                        on: {
                          click: function($event) {
                            _vm.showPicPopup(
                              _vm.qualification.taxCertificatePic
                            )
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.qualification.taxCertificatePic,
                            alt: ""
                          }
                        })
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.settledInfo != null
      ? _c("div", { staticClass: "view-box" }, [
          _c("div", { staticClass: "view-title" }, [_vm._v("签约信息")]),
          _vm._v(" "),
          _c("div", { staticClass: "shop-detail" }, [
            _c("ul", [
              _c("li", [
                _c("span", [_vm._v("入驻社区：")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.settledCommunity))])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "category" }, [
                _c("span", [_vm._v("入驻类目：")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "category-list" },
                  _vm._l(_vm.settledInfo.enterCatalogs, function(
                    firstItem,
                    firstIndex
                  ) {
                    return _c(
                      "div",
                      { key: firstIndex, staticClass: "category-item" },
                      [
                        _c("div", { staticClass: "first" }, [
                          _vm._v(_vm._s(firstItem.catagoryName))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "second" },
                          _vm._l(firstItem.subCatalogs, function(
                            secItem,
                            secIndex
                          ) {
                            return _c(
                              "div",
                              { key: secIndex, staticClass: "second-item" },
                              [
                                _c("p", [_vm._v(_vm._s(secItem.catagoryName))]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  _vm._l(secItem.subCatalogs, function(
                                    thirdItem,
                                    thirdIndex
                                  ) {
                                    return _c("i", { key: thirdIndex }, [
                                      _vm._v(_vm._s(thirdItem.catagoryName))
                                    ])
                                  })
                                )
                              ]
                            )
                          })
                        )
                      ]
                    )
                  })
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", [_vm._v("物业分佣：")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      (parseFloat(_vm.settledInfo.propertyScale) * 100).toFixed(
                        2
                      )
                    ) + "%"
                  )
                ])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showPopup
      ? _c(
          "div",
          {
            staticClass: "pic-popup",
            on: {
              click: function($event) {
                _vm.showPicPopup("none")
              }
            }
          },
          [
            _c(
              "a",
              { staticClass: "close-btn", attrs: { href: "javascript:;" } },
              [_vm._v("×")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "img-view" }, [
              _c("img", { attrs: { src: _vm.imgView, alt: "" } })
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }